import type { FunctionComponent } from 'react'
import React, { useContext } from 'react'

import { PillButtonPage } from '../../../../shared/pages/PillButtonPage'
import { ToolContext } from '../../../../shared/state/appContext'
import { formatToolName } from '../../../../shared/utils/formatToolName'
import { generalDataLayer } from '../../../../shared/utils/tracking'
import { DealerOfferedSolutionFlow, WhichDealerFlow } from '../../pageFlowData'
import { dealerOfferedSolutionData } from './data'

export const DealerOfferedSolution: FunctionComponent = () => {
  const { state, dispatch } = useContext(ToolContext)
  const {
    initial: { entryToolName },
    car: { dealerOfferedSolution },
  } = state

  const handleTracking = (id: string) => {
    const trackingAnswer = `question | ${DealerOfferedSolutionFlow.VIEW_NAME} | ${id}`
    generalDataLayer(formatToolName(entryToolName), trackingAnswer, false)
  }

  const handleDispatch = (id: string) => {
    dispatch({ type: 'UPDATE_DEALER_OFFERED_SOLUTION', data: id })
    dispatch({ type: 'UPDATE_STEP', data: WhichDealerFlow.STEP })
    dispatch({ type: 'UPDATE_PROGRESS_VALUE', data: WhichDealerFlow.PROGRESS_VALUE })
  }

  const handleSubmit = (id: string) => {
    handleTracking(id)
    handleDispatch(id)
  }

  const { buttons, imgObj, title } = dealerOfferedSolutionData

  return (
    <div>
      <PillButtonPage
        buttons={buttons}
        defaultValue={dealerOfferedSolution ? dealerOfferedSolution : ''}
        handleSubmit={handleSubmit}
        imgObj={imgObj}
        title={title}
      />
    </div>
  )
}
